import React from 'react';
import {Button, Divider, Input, message, Modal, Select, Table, Tag} from 'antd';
import WebServerRestClient from "../../tools/WebServerRestClient";
import UserComponent from "../../components/UserComponent";
import CommonUtils from "../../tools/CommonUtils";

const { Option } = Select;
const { TextArea } = Input;

const ruleTypeList = [
    {value: 'PROXY', label: 'Proxy'},
    {value: 'DIRECT', label: 'Direct'},
    {value: 'BLOCK', label: 'Block'}
];

const ruleKindList = [
    {value: 'IP', label: 'IP'},
    {value: 'DOMAIN', label: 'Domain'}
];

const enabledOptions = [
    {value: 'true', label: 'Enabled'},
    {value: 'false', label: 'Disabled'}
];

export default class SplitTunnelRuleList extends UserComponent {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            confirmLoading: false,
            showEditModal: false,
            dataList: [],
            totalCount: 0,
            query_params: {},
            form_params: {}
        }
    }

    componentDidMount() {
        this.loadListData();
    }

    handleQuerySelectChange(name, value) {
        let query_params = Object.assign({}, this.state.query_params);
        query_params[name] = value;
        this.setState({query_params: query_params});
    }

    handleFormInputChange(event) {
        const target = event.target;
        const name = target.name;
        let value = target.value;
        if (name !== 'remarks') {
            value = value.trim();
        }
        let form_params = Object.assign({}, this.state.form_params);
        form_params[name] = value;
        this.setState({form_params: form_params});
    }

    handleFormSelectChange(name, value) {
        let form_params = Object.assign({}, this.state.form_params);
        form_params[name] = value;
        this.setState({form_params: form_params});
    }

    buildQueryParams() {
        let params = Object.assign({}, this.state.query_params);
        if (!params.ruleType) {
            delete params.ruleType;
        }
        if (!params.ruleKind) {
            delete params.ruleKind;
        }
        if (typeof params.enabled === 'undefined') {
            delete params.enabled;
        }
        return params;
    }

    loadListData() {
        this.setState({loading: true});
        new WebServerRestClient().GET('/admin/split-tunnel/rules', this.buildQueryParams())
            .then(response => {
                this.setState({loading: false});
                if (response.code === 200) {
                    let dataList = response.data || [];
                    this.setState({
                        dataList: dataList,
                        totalCount: dataList.length
                    });
                } else if (response.code === 401 || response.code === 403) {
                    this.props.history.push('/login');
                } else {
                    message.error(response['msg']);
                }
            }).catch(err => {
                this.setState({loading: false});
                message.error("Error: " + err.message);
            });
    }

    openCreateModal() {
        this.setState({
            showEditModal: true,
            form_params: {
                addFlag: true,
                ruleType: 'PROXY',
                ruleKind: 'IP',
                enabled: 'true'
            }
        });
    }

    openModifyModal(record) {
        let form_params = Object.assign({}, record);
        form_params.addFlag = false;
        form_params.enabled = record.enabled === true ? 'true' : 'false';
        this.setState({
            showEditModal: true,
            form_params: form_params
        });
    }

    isEmptyFormValue(value) {
        return typeof value === 'undefined' || value === null || value === '';
    }

    buildSaveParams(form_params) {
        return {
            ruleType: form_params.ruleType,
            ruleKind: form_params.ruleKind,
            ruleValue: form_params.ruleValue,
            enabled: form_params.enabled !== 'false',
            remarks: form_params.remarks
        };
    }

    saveOrUpdateRecord() {
        let form_params = this.state.form_params;
        if (this.isEmptyFormValue(form_params.ruleType)) {
            message.warn('Please select a rule type.');
            return false;
        }
        if (this.isEmptyFormValue(form_params.ruleKind)) {
            message.warn('Please select a rule kind.');
            return false;
        }
        if (this.isEmptyFormValue(form_params.ruleValue)) {
            message.warn('Rule value is empty.');
            return false;
        }

        let request_params = this.buildSaveParams(form_params);
        let request = form_params.addFlag ?
            new WebServerRestClient().POST('/admin/split-tunnel/rules', request_params) :
            new WebServerRestClient().POST('/admin/split-tunnel/rules/' + form_params.id, request_params);

        this.setState({confirmLoading: true});
        request.then(response => {
            this.setState({confirmLoading: false});
            if (response.code === 200) {
                this.setState({showEditModal: false});
                this.loadListData();
            } else if (response.code === 401 || response.code === 403) {
                this.props.history.push('/login');
            } else {
                message.warn(response['msg']);
            }
        }).catch(err => {
            this.setState({confirmLoading: false});
            message.error("Error: " + err.message);
        });
    }

    formatTimestamp(timestamp) {
        if (!timestamp) {
            return '';
        }
        let time = Number(timestamp);
        if (isNaN(time)) {
            return timestamp;
        }
        if (time < 1000000000000) {
            time *= 1000;
        }
        return CommonUtils.formatDate(new Date(time), 'yyyy-MM-dd hh:mm:ss');
    }

    renderEnabled(value) {
        if (value === true) {
            return <Tag color="green">Enabled</Tag>
        }
        return <Tag color="red">Disabled</Tag>
    }

    renderRuleType(value) {
        if (value === 'PROXY') {
            return <Tag color="blue">PROXY</Tag>
        } else if (value === 'DIRECT') {
            return <Tag color="green">DIRECT</Tag>
        } else if (value === 'BLOCK') {
            return <Tag color="red">BLOCK</Tag>
        }
        return value;
    }

    render() {
        return (
            <div className="container">
                <div className="toolbar">
                    <Select style={{width: 150}}
                            placeholder="select type"
                            allowClear={true}
                            onChange={(value) => this.handleQuerySelectChange('ruleType', value)}>
                        {ruleTypeList.map(item => (
                            <Option key={item.value} value={item.value}>{item.label}</Option>
                        ))}
                    </Select>
                    <Divider type="vertical"/>
                    <Select style={{width: 150}}
                            placeholder="select kind"
                            allowClear={true}
                            onChange={(value) => this.handleQuerySelectChange('ruleKind', value)}>
                        {ruleKindList.map(item => (
                            <Option key={item.value} value={item.value}>{item.label}</Option>
                        ))}
                    </Select>
                    <Divider type="vertical"/>
                    <Select style={{width: 150}}
                            placeholder="select status"
                            allowClear={true}
                            onChange={(value) => this.handleQuerySelectChange('enabled', value)}>
                        {enabledOptions.map(item => (
                            <Option key={item.value} value={item.value}>{item.label}</Option>
                        ))}
                    </Select>
                    <Divider type="vertical"/>
                    <Button type="primary" icon="search" className="search_btn" loading={this.state.loading}
                            onClick={this.loadListData.bind(this)}>Search</Button>
                    <div className="button_group">
                        <Button type="link" icon="file-add" size={"small"}
                                onClick={this.openCreateModal.bind(this)}>Create</Button>
                    </div>
                </div>

                <div className="total_bar">
                    <span className="right">
                        Total of <b style={{color:'red'}}>{this.state.totalCount}</b> Records
                    </span>
                </div>

                <Table loading={this.state.loading}
                       rowKey={(record) => record.id || `${record.ruleType}_${record.ruleKind}_${record.ruleValue}`}
                       size={'small'}
                       columns={[
                           {title: 'ID', dataIndex: 'id', align: 'center'},
                           {
                               title: 'Type',
                               dataIndex: 'ruleType',
                               align: 'center',
                               render: (value) => this.renderRuleType(value)
                           },
                           {title: 'Kind', dataIndex: 'ruleKind', align: 'center'},
                           {
                               title: 'Value',
                               dataIndex: 'ruleValue',
                               align: 'left',
                               render: (value) => <span style={{wordBreak: 'break-all'}}>{value}</span>
                           },
                           {
                               title: 'Status',
                               dataIndex: 'enabled',
                               align: 'center',
                               render: (value) => this.renderEnabled(value)
                           },
                           {
                               title: 'CreatedTime',
                               dataIndex: 'createdTime',
                               align: 'center',
                               render: (value) => this.formatTimestamp(value)
                           },
                           {title: 'Remarks', dataIndex: 'remarks', align: 'left'},
                           {
                               title: 'Action',
                               key: 'action',
                               align: 'center',
                               render: (text, record) => (
                                   <span>
                                       <Button type="link" size={"small"}
                                               onClick={() => this.openModifyModal(record)}>Modify</Button>
                                  </span>
                               ),
                           },
                       ]}
                       dataSource={this.state.dataList}
                       pagination={false}/>

                <Modal
                    title={this.state.form_params.addFlag ? 'Create Split Tunnel Rule' : 'Modify Split Tunnel Rule'}
                    keyboard={false}
                    maskClosable={false}
                    destroyOnClose={true}
                    visible={this.state.showEditModal}
                    onCancel={() => this.setState({showEditModal: false})}
                    onOk={() => this.saveOrUpdateRecord()}
                    confirmLoading={this.state.confirmLoading}
                    okText="Save"
                    cancelText="Cancel">
                    <Select className="width_100"
                            placeholder="select rule type"
                            value={this.state.form_params.ruleType}
                            onChange={(value) => this.handleFormSelectChange('ruleType', value)}>
                        {ruleTypeList.map(item => (
                            <Option key={item.value} value={item.value}>{item.label}</Option>
                        ))}
                    </Select>
                    <Select className="width_100 mt_10"
                            placeholder="select rule kind"
                            value={this.state.form_params.ruleKind}
                            onChange={(value) => this.handleFormSelectChange('ruleKind', value)}>
                        {ruleKindList.map(item => (
                            <Option key={item.value} value={item.value}>{item.label}</Option>
                        ))}
                    </Select>
                    <Input name={'ruleValue'} placeholder={'rule value'}
                           className="mt_10 width_100"
                           value={this.state.form_params.ruleValue || ''}
                           onChange={this.handleFormInputChange.bind(this)}/>
                    <Select className="width_100 mt_10"
                            placeholder="select status"
                            value={this.state.form_params.enabled}
                            onChange={(value) => this.handleFormSelectChange('enabled', value)}>
                        {enabledOptions.map(item => (
                            <Option key={item.value} value={item.value}>{item.label}</Option>
                        ))}
                    </Select>
                    <TextArea name={'remarks'} rows={4} placeholder={'remarks'}
                              className="mt_10 width_100"
                              value={this.state.form_params.remarks || ''}
                              onChange={this.handleFormInputChange.bind(this)}/>
                </Modal>
            </div>
        )
    }
}
